export const FOCUS_CONTAINER_KEY = 'esc';
export const DEBOUNCE_TIMEOUT = 300;
